function rtPrevPost() {
    var el = document.querySelector('#rt-posts-preview');
    el.children[rtPost]?.style.display = "none";
    if (rtPost === 0){
        rtPost = el.children.length - 1;
    } else {
        rtPost = rtPost - 1;
    }
    el.children[rtPost]?.style.display = "flex";
    // setFocus(el.children[rtPost]);
    el.children[rtPost].querySelector('.rt-project-button-link').focus();
}

function rtNextPost() {
    var el = document.querySelector('#rt-posts-preview');
    el.children[rtPost]?.style.display = "none";
    if (rtPost === (el.children.length - 1)){
        rtPost = 0;
    } else {
        rtPost = rtPost + 1;
    }
    el.children[rtPost]?.style.display = "flex";
    el.children[rtPost].querySelector('.rt-project-button-link').focus();
}

function toggle(id) {
    const element = document.querySelector(id);
    element.classList.toggle("rt-hide");
}